var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "flex flex-grow flex-col items-center justify-center w-full h-full"
    },
    [
      _c("BaseIcon", {
        staticClass: "w-48 h-48 mb-4",
        attrs: { name: "media-kraken-confused" }
      }),
      _c("h2", { staticClass: "text-2xl font-semibold" }, [
        _vm._v(" 404: Not Found ")
      ]),
      _c("BaseLink", { staticClass: "mt-2", attrs: { route: "home" } }, [
        _vm._v(" go home ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }